/**
 * Created by mykurisu on 2017/11/1.
 */
const defaults = {
    code: null,
    hasCoupon: false,
    //是否显示选择面板
    selectCouponShow: false,
    couponData: null,
    //是否拥有已领取的优惠券
    canUseCouponBuy: false,
    //不想使用优惠券
    dontWantUseCoupon: false,
};

export default (state=defaults, action) => {
    switch (action.type) {
        case 'NEW_COUPON_CHECKED':
            return {
                ...state,
                hasCoupon: true
            };
        case 'NEW_COUPON_DATA':
            return{
                ...state,
                couponData: action.payload
            };
        case 'COUPON_USE_BUY':
            return {
                ...state,
                canUseCouponBuy: true
            };
        case 'COUPON_DONT_WANT_USE':
            return {
                ...state,
                dontWantUseCoupon: action.payload
            };
        case 'COUPON_SELECT_SHOW':
            return {
                ...state,
                selectCouponShow: true
            };
        case 'COUPON_SELECT_HIDE':
            return {
                ...state,
                selectCouponShow: false
            };
        case 'COUPON_SETTING':
            return {...state,
                code: action.payload.code,
            };
        case 'COUPON_REMOVE':
            return {...state,
                code: null,
            };
        case 'COUPON_CLEAR':
            return defaults;
        default:
            return state;
    }
}




// WEBPACK FOOTER //
// ./src/reducers/newCoupon.js